import { TelemedicineParticipant } from '@/api/telemedicine-api';

interface ParticipantsListProps {
  participants: TelemedicineParticipant[];
  localUserId?: string;
}

const ROLE_LABELS: Record<string, string> = {
  DOCTOR: 'Médico(a)',
  PATIENT: 'Paciente',
  ADMIN: 'Administrador',
  SUPPORT: 'Suporte',
};

const STATUS_LABELS: Record<string, string> = {
  JOINED: 'Conectado',
  CONNECTED: 'Ao vivo',
  NOT_JOINED: 'Aguardando',
  LEFT: 'Saiu',
  DISCONNECTED: 'Desconectado',
  RECONNECTING: 'Reconectando...',
};

export function ParticipantsList({ participants, localUserId }: ParticipantsListProps) {
  if (participants.length === 0) {
    return (
      <div className="text-xs text-muted-foreground p-3 text-center">
        Nenhum participante conectado no momento
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      {participants.map(p => {
        const isLocal = p.userId === localUserId;
        const isConnected = p.status === 'CONNECTED' || p.status === 'JOINED';
        const statusColor = isConnected ? 'bg-emerald-500' : 'bg-neutral-400';
        const roleLabel = ROLE_LABELS[p.role] || p.role;
        const statusLabel = STATUS_LABELS[p.status] || p.status;

        return (
          <div
            key={p.id}
            className="flex items-center gap-2 px-2.5 py-1.5 bg-background dark:bg-neutral-800/80 border border-border dark:border-neutral-700/80 rounded-xl shadow-2xs"
          >
            <span className={`w-2 h-2 rounded-full ${statusColor} shrink-0`} aria-label={statusLabel} />
            <span className="text-xs font-semibold text-foreground truncate">
              {roleLabel}
              {isLocal && <span className="text-muted-foreground font-normal"> (Você)</span>}
            </span>
            <span className="text-[11px] font-medium text-muted-foreground ml-auto shrink-0">
              {statusLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
}